<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Finance Report</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Content -->
            <GChart
              type="ColumnChart"
              :data="chartData"
              :options="chartOptions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from "vue-google-charts";
export default {
  name: "finance_report",
  components: {
    GChart
  },

  data() {
    return {
      chartData: [],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017"
        }
      }
    };
  }
};
</script>
